import React from 'lib/react';
import PropTypes from 'prop-types';
import BingMap from './BingMap.component';
import EmbeddedExplorer from './EmbeddedExplorer.component';

/**
 * Map component that conditionally renders either BingMap or EmbeddedExplorer
 * based on the useEmbeddedExplorer prop.
 */
function MapComponent(props) {
  const {
    useEmbeddedExplorer, loadingComponent, errorFallback, ...restProps
  } = props;
  // loadingComponent and errorFallback are ignored since lazy loading is removed
  return useEmbeddedExplorer ? (
    <EmbeddedExplorer {...restProps} />
  ) : (
    <BingMap {...restProps} />
  );
}
MapComponent.defaultProps = {
  useEmbeddedExplorer: false,
  loadingComponent: null,
  errorFallback: null,
};
MapComponent.propTypes = {
  /** Whether to use EmbeddedExplorer instead of BingMap */
  useEmbeddedExplorer: PropTypes.bool,
  /** Custom loading component to show while map is loading (unused) */
  loadingComponent: PropTypes.elementType,
  /** Custom error fallback component (unused) */
  errorFallback: PropTypes.elementType,
};
export default MapComponent;
